import { SvgIcon, useTheme } from "@mui/material";
import type React from "react";
import { useState } from "react";
import { tileTextStyle } from "./style.ts";

const UtilityVehicles: React.FC<{ selected: boolean }> = ({ selected }) => {
	const [hovered, setHovered] = useState(false);
	const theme = useTheme();
	const idleBackground = theme.palette.secondary.main;
	const hoverBackground = theme.palette.secondary.light;
	const selectedBackGround = theme.palette.info.main;

	const backGroundColor = selected ? selectedBackGround : hovered ? hoverBackground : idleBackground;
	return (
		<SvgIcon
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			viewBox="0 0 460 259"
			sx={{ width: "100%", height: "auto" }}
		>
			<rect fill={backGroundColor} width="460" height="259" />
			<line stroke="#fff" x1="460" y1="237.2" x2="0" y2="237.2" />
			<g>
				<path
					stroke="#fff"
					fill="none"
					d="M176.8,219.5l-6,.6s-7.7,0-15.1-6.7-5.8-9.4-5.8-9.4v-15.6c-.1,0,4.8-6,4.8-6,0,0,2.5-12.3,3.9-13.3s27.9-18.6,27.9-18.6l32.3-36.1s3.7-4.2,9.8-4.1,192.8-.4,192.8-.4c0,0,6.6-1.6,7.6,8,1,9.6,4.2,82.3,4.2,82.3,0,0,4.5,1.3,4.5,6.3s.4,8-4.4,9.4-22.2,4.7-24.1,4.5h-3.8"
				/>
				<line stroke="#fff" fill="none" x1="231.3" y1="221.1" x2="347.8" y2="221.9" />
				<polyline stroke="#fff" fill="none" points="158.5 169.5 175.1 169.5 172 182.1 155 182.1" />
				<path
					stroke="#fff"
					fill="none"
					d="M220.7,121.1l-21.9,25.9s-2.7,3.2,1.9,3.3,59.7,0,59.7,0c0,0,6.1,0,6.1-3.5s-.1-24.3-.1-24.3c0,0,.2-3.9-2.4-3.9s-39.7-.2-39.7-.2c0,0-1.5-.2-2.5,1.2l-1.1,1.4Z"
				/>
				<path
					stroke="#fff"
					fill="none"
					d="M207.4,180.7s19.7-.9,26.7,12.2c6.3,11.8,5.9,14.7,5.9,14.7,0,0-.5,4.5,1.6,4.5s31.1.2,31.1.2c0,0,3.7-.4,3.8-4.9s0-4.4-.2-89.3"
				/>
				<polyline stroke="#fff" fill="none" points="431.7 167.5 424.7 171.7 424.7 189.4 432.4 191.3" />
				<circle stroke="#fff" fill="none" cx="202.9" cy="213.3" r="8" />
				<circle stroke="#fff" fill="none" cx="203.1" cy="214.2" r="22.2" />
				<circle stroke="#fff" fill="none" cx="378.4" cy="213.5" r="8" />
				<circle stroke="#fff" fill="none" cx="378.5" cy="214.4" r="22.2" />
				<path stroke="#fff" fill="none" d="M292.1,119.1l118.2.4s5.5-1,5.3,3.5-1.2,20.5-4,24.9-12,2.5-12,2.5h-107" />
			</g>
			<text
        style={tileTextStyle}
        x="20" y="44"
      >
				Užitková vozidla
			</text>
		</SvgIcon>
	);
};

export default UtilityVehicles;
